module.exports = __webpack_public_path__ + "static/img/login_left.24b7e5f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bnu/login_left.png
// module id = MLRA
// module chunks = 171